'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * An extended Array to represent collections of models.
 */
var Collection = /** @class */ (function (_super) {
    __extends(Collection, _super);
    function Collection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Convert results by determining whether the result is instantiable or not.
     * @param {Spell} spell
     * @param {Array} rows
     * @param {Array} fields
     * @returns {Collection|Array}
     */
    Collection.init = function (_a) {
        var spell = _a.spell, rows = _a.rows, fields = _a.fields, insertId = _a.insertId, affectedRows = _a.affectedRows;
        if (spell.command !== 'select')
            return { insertId: insertId, affectedRows: affectedRows };
        return dispatch(spell, rows, fields);
    };
    /**
     * Override JSON.stringify behavior
     * @returns {Object[]}
     */
    Collection.prototype.toJSON = function () {
        return Array.from(this, function (element) {
            if (typeof element.toJSON === 'function')
                return element.toJSON();
            return element;
        });
    };
    /**
     * @returns {Object[]}
     */
    Collection.prototype.toObject = function () {
        return Array.from(this, function (element) {
            if (typeof element.toObject === 'function')
                return element.toObject();
            return element;
        });
    };
    /**
     * Save the collection. Currently the changes are made concurrently but NOT in a transaction.
     * @returns {Bone[]}
     */
    Collection.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.length === 0)
                            return [2 /*return*/, this];
                        if (this.some(function (element) { return !element.save; })) {
                            throw new Error('Collection contains element that cannot be saved.');
                        }
                        return [4 /*yield*/, Promise.all(this.map(function (element) { return element.save(); }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return Collection;
}(Array));
/**
 * Check if the query result of spell is instantiatable by examining the query structure.
 * - https://www.yuque.com/leoric/blog/ciiard#XoI4O (zh-CN)
 * @param {Spell} spell
 * @returns {boolean}
 */
function instantiatable(spell) {
    var columns = spell.columns, groups = spell.groups, Model = spell.Model;
    var columnAttributes = Model.columnAttributes, tableAlias = Model.tableAlias;
    if (groups.length > 0)
        return false;
    if (columns.length === 0)
        return true;
    return columns
        .filter(function (_a) {
        var qualifiers = _a.qualifiers;
        return (!qualifiers || qualifiers.includes(tableAlias));
    })
        .every(function (_a) {
        var value = _a.value;
        return columnAttributes[value];
    });
}
/**
 * Convert the results to collection that consists of models with their associations set up according to `spell.joins`.
 * @private
 * @param {Spell} spell
 * @param {Object[]} rows
 * @param {Object[]} fields
 * @returns {Collection}
 */
function dispatch(spell, rows, fields) {
    var e_1, _a;
    var groups = spell.groups, joins = spell.joins, columns = spell.columns, Model = spell.Model;
    var tableAlias = Model.tableAlias, table = Model.table, primaryKey = Model.primaryKey, primaryColumn = Model.primaryColumn, attributeMap = Model.attributeMap;
    // await Post.count()
    if (rows.length <= 1 && columns.length === 1 && groups.length === 0) {
        var _b = columns[0], type = _b.type, value = _b.value, args = _b.args;
        if (type === 'alias' && args && args[0].type === 'func') {
            var row = rows[0];
            var record = row && (row[''] || row[table]);
            var result = record && record[value];
            return result;
        }
    }
    var joined = Object.keys(joins).length > 0;
    var canInstantiate = instantiatable(spell);
    var results = new Collection();
    var _loop_1 = function (row) {
        var result = Object.keys(row).reduce(function (res, prop) {
            var data = row[prop];
            var qualifier = prop === table ? tableAlias : prop;
            if (qualifier === '' || qualifier === tableAlias) {
                Object.assign(res, data);
            }
            else {
                if (Object.values(data).some(function (value) { return value != null; })) {
                    res[prop] = data;
                }
            }
            return res;
        }, {});
        var current = void 0;
        if (joined && result[primaryColumn] != null) {
            current = results.find(function (r) { return r[primaryKey] == result[primaryColumn]; });
        }
        if (!current) {
            current = canInstantiate || (groups.length === 0 && Object.keys(result).every(function (key) { return attributeMap[key]; }))
                ? Model.instantiate(result)
                : Model.alias(result);
            results.push(current);
        }
        if (joined) {
            dispatchJoins(current, spell, row, fields);
        }
    };
    try {
        for (var rows_1 = __values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
            var row = rows_1_1.value;
            _loop_1(row);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (rows_1_1 && !rows_1_1.done && (_a = rows_1.return)) _a.call(rows_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return results;
}
function dispatchJoins(current, spell, row, fields) {
    var _loop_2 = function (qualifier) {
        var join = spell.joins[qualifier];
        var Model = join.Model, hasMany = join.hasMany;
        // mysql2 nests rows with table name instead of table alias.
        var values = row[qualifier] || row[Model.table];
        if (!values)
            return "continue";
        if (hasMany) {
            var id_1 = values[Model.primaryColumn];
            if (!current[qualifier])
                current[qualifier] = new Collection();
            if (!Array.isArray(current[qualifier])) {
                var instance = Model.instantiate(current[qualifier]);
                current[qualifier] = new Collection();
                if (Object.values(values).some(function (value) { return value != null; })) {
                    current[qualifier].push(instance);
                }
            }
            if (!id_1 || current[qualifier].some(function (item) { return item[Model.primaryKey] === id_1; }))
                return "continue";
            current[qualifier].push(Model.instantiate(values));
        }
        else {
            current[qualifier] = Object.values(values).some(function (value) { return value != null; })
                ? Model.instantiate(values)
                : null;
        }
    };
    for (var qualifier in spell.joins) {
        _loop_2(qualifier);
    }
}
module.exports = Collection;
//# sourceMappingURL=collection.js.map